import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import AppMenu from './AppMenu'
import { classNames } from 'primereact/utils'

const AppTopbar = (props) => {
  const onTopbarSubItemClick = (event) => {
    event.preventDefault()
  }

  const history = useHistory()
  const logout = function (e) {
    e.preventDefault()
    localStorage.clear()
    return (window.location.href = '/boleto')
  }

  return (
    <>
      <div className='layout-topbar'>
        <div className='layout-topbar-left'>
          <button
            className='topbar-menu-button p-link'
            onClick={props.onMenuButtonClick}
          >
            <i className='pi pi-bars'></i>
          </button>

          <button
            className='logo p-link lg:pt-2'
            onClick={() => history.push('/')}
          >
            <img src={`assets/images/logo.png`} alt='logo' />
          </button>
        </div>

        <AppMenu
          model={props.items}
          menuMode={props.menuMode}
          colorScheme={props.colorScheme}
          menuActive={props.menuActive}
          activeInlineProfile={props.activeInlineProfile}
          onSidebarMouseOver={props.onSidebarMouseOver}
          onSidebarMouseLeave={props.onSidebarMouseLeave}
          toggleMenu={props.onToggleMenu}
          onChangeActiveInlineMenu={props.onChangeActiveInlineMenu}
          onMenuClick={props.onMenuClick}
          onRootMenuItemClick={props.onRootMenuItemClick}
          onMenuItemClick={props.onMenuItemClick}
        />

        <div className='layout-topbar-right'>
          <ul className='layout-topbar-right-items'>
            <li
              id='profile'
              className={classNames('profile-item', {
                'active-topmenuitem': props.topbarMenuActive,
              })}
            >
              <button className='p-link' onClick={props.onTopbarItemClick}>
                <img
                  src='assets/layout/images/profile-image.png'
                  alt='profile'
                />
              </button>

              <ul className='fadeInDown'>
                <li role='menuitem'>
                  <Link to='/Perfil'>
                    <button type='button' className='p-link'>
                      <i className='pi pi-fw pi-user'></i>
                      <span>Perfil</span>
                    </button>
                  </Link>
                </li>
                <li role='menuitem'>
                  <Link>
                    <button className='p-link' onClick={logout}>
                      <i className='pi pi-fw pi-sign-out'></i>
                      <span>Sair</span>
                    </button>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default AppTopbar
